import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {INACTIVE_PRODUCT_MAX_NAME_LENGTH} from '~/constants/NotificationConstants';
import {metrics} from '~/vendor/metrics';
import {Button} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function InactiveProductNotification(props) {
  const {dismiss, notification} = props;
  const {product} = notification;

  metrics.setDimension('discontinuedProductStyle', product?.id);

  return (
    <Notification title="This product is currently unavailable">
      {product?.name.length < INACTIVE_PRODUCT_MAX_NAME_LENGTH ? (
        <p>
          <span>{`We're sorry, the ${product?.name}`}</span>
          <span>
            is currently unavailable. Please select a different product
          </span>
        </p>
      ) : (
        <p>{`We're sorry, ${
          product?.name ? `the ${product?.name}` : 'this product'
        } is currently unavailable.  Please select a different product`}</p>
      )}
      <Button
        size="large"
        variant="Primary"
        className="notification-cta"
        href={`#/productCatalog/${product?.primary_category_id || ''}`}
        onClick={dismiss}>
        Swap Product
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    product: PropTypes.object
  })
};

InactiveProductNotification.propTypes = propTypes;

InactiveProductNotification.displayName = 'InactiveProductNotification';
